export const CacheKey = {
	getArtists: "getArtists",
	getCheckIns: "getCheckIns",
	getCheckInDetail: "getCheckInDetail",
	getCheckInStatus: "getCheckInStatus",
	getUserInfo: "getUserInfo",
	getCheckInUsers: "getCheckInUsers",
	getNotices: "getNotices",
	getNotice: "getNotice",
	getSecurityPledge: "getSecurityPledge",
};

export const StoreKey = {
	queryArtist: "artist",
	queryPage: "page",
	queryTicketCode: "ticketCode",
	mainArtist: "mainArtist",
	sessionToken: "sessionToken",
	verifyToken: "verifyToken",
	loginPhase: "phase",
	backstageToken: "web_access_token",
};

export const SupportedLanguages = ["ko", "ja", "en"];
